module.exports = __webpack_public_path__ + "media/images/icon_clip-c54c80c8e5563caaab76c84bff330ea8.svg";